import Router from "vue-router";

import { INIT, UPDATE_AUTH_SEEN } from "@/store/actions";
import { UPDATE_USER_READING } from "@/store/actions";

// App
import App from "@/modules/app/";

// J.L. AI
import JlAi from "@/modules/app/JL/";
import PdfNumerologyGenerator from "@/modules/app/JL/PdfNumerologyGenerator";

// Auth
import Register from "@/modules/auth/Register";
import Login from "@/modules/auth/Login";
import Logout from "@/modules/auth/Logout";
import Password from "@/modules/auth/Password";
import Profile from "@/modules/auth/Profile";

// Web
import Numerology from "@/modules/web/Numerology/";
import NumerologySale from "@/modules/web/Numerology/SalePageFull";
import NumerologyPayment from "@/modules/web/Numerology/PaymentPage";
import NumerologyPaymentSuccess from "@/modules/web/Numerology/SuccessPage";

const routes = [
	{
		path: "/app",
		name: "welcome",
		component: App,
		meta: { auth: false },
		redirect: { name: "dashboard" },
		children: [
			{
				path: "/dashboard",
				name: "dashboard",
				component: JlAi,
				meta: { auth: true, title: "Accueil" },
			},

			{
				path: "/profile",
				name: "profile",
				component: Profile,
				meta: { auth: true, title: "Mon Profil" },
			},

			{
				path: "/numerology-pdf",
				name: "numerology-pdf",
				component: PdfNumerologyGenerator,
				meta: { auth: false, title: "Générateur PDF" },
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: Login,
		meta: { title: "Connection" },
	},
	{
		path: "/logout",
		name: "logout",
		component: Logout,
		meta: { title: "Déconnection" },
	},
	{
		path: "/password",
		name: "password",
		component: Password,
		meta: { title: "Mot De Passe Oublié" },
	},
	{
		path: "/register",
		name: "register",
		component: Register,
		meta: { title: "Inscription" },
	},
	{
		path: "*",
		redirect: { name: "dashboard" },
	},
	{
		path: "/numerology",
		name: "numerology",
		component: Numerology,
		meta: { title: "Numérologie" },
	},
	{
		path: "/numerology/payment",
		name: "numerology-payment",
		component: NumerologyPayment,
		props: true,
		meta: { title: "Numérologie Payment Page" },
	},
	{
		path: "/numerology/payment/success",
		name: "numerology-payment-success",
		component: NumerologyPaymentSuccess,
		meta: { title: "Numérologie Successful Payment" },
	},
	{
		path: "/numerology/sale",
		name: "numerology-sale",
		component: NumerologySale,
		meta: { title: "Numérologie Sale Page" },
	},


];

const router = new Router({ mode: "history", routes });

export const applyBeforeEachRouterHook = (store) => {
	const initPromise = store.dispatch(INIT);

	router.beforeEach((to, _, next) => {
		initPromise.then(() => {
			const { title = null } = to.meta;
			document.title = title ? `${title} : J.L. AI®` : "J.L. AI®";

			const isAuthenticated = store.getters["auth/isAuthenticated"];
			const authIsRequired = to.matched.some((record) => record.meta.auth);
			const currentUser = store.getters["auth/currentUser"];
			const { isBanned } = currentUser;

			if (!!isBanned && to.name !== "login") {
				return next({ name: "login" });
			}
			if (isAuthenticated) {
				store.dispatch(`auth/${UPDATE_AUTH_SEEN}`);
			}

			if (authIsRequired && !isAuthenticated) {
				return next({ name: "login" });
			}

			let myTopicId = localStorage.getItem("topic");
			if (to.name === "topic") {
				if (!myTopicId) {
					localStorage.setItem("topic", to.params.topicId);
					store.dispatch(`community/${UPDATE_USER_READING}`, {
						topicId: to.params.topicId,
						flag: true,
					});
				}
			} else {
				if (myTopicId) {
					localStorage.removeItem("topic");
					store.dispatch(`community/${UPDATE_USER_READING}`, {
						topicId: myTopicId,
						flag: false,
					});
				}
			}

			return next();
		});
	});
};

export default router;
